import React from 'react';
import PropTypes from 'prop-types';

import { ApiDataContext } from './';

export class ApiDataContextProvider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
	};

	state = {
		apiCacheTrigger: 0,
	};

	clearApiCache = () => {
		this.setState({ apiCacheTrigger: Date.now() });
	};

	render() {
		return (
			<ApiDataContext.Provider
				value={{ ...this.state, clearApiCache: this.clearApiCache }}
			>
				{this.props.children}
			</ApiDataContext.Provider>
		);
	}
}
